import Component from '../abstracts/Component';
import MenuItem from './header/MenuItem';
import {showPanel} from './header/MenuItem';

export default class HeaderComponent extends Component {
  get SELECTORS() {
    return {
      burgerMenu: '[data-trigger-menu]',
      searchBtn: '[data-trigger-search]',
      layersContainer: '[data-menu-layers]',
      menuItems: '[data-menu-item]',
      benefitBar: '[data-benefit-bar]',
      searchLayer: '[data-search]',
      searchOverlay: '[data-search-overlay]',
      searchMobile: '[data-search-mobile]',
      searchHeightMobile: '[data-search-height-mobile]',
      actionsMobileSearch: '[data-actions-mobile-search]',
      menuItemsLinkSel : '[data-menu-item] a'
    };
  }

  get CSS_CUSTOMVARS() {
    return {
      jsHeightHeader: '--js-header-height',
      jsVh: '--vh',
    };
  }

  get CSS_CLASSNAMES() {
    return {
      burgerOpen: 'menu-open',
      showMenu: 'show-menu',
      activeLayersContainer: 'active-layers',
      headerIsSticky: 'header-is-sticky',
      searchOpen: 'search-open',
      searchLayerOpened: '--search-layer-opened',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.menuItems = [];
    this.menuIsOpen = false;
    this.searchIsOpen = false;
    this.burgerMenu = this.$component.querySelector(this.SELECTORS.burgerMenu);
    this.searchBtnItems = this.$component.querySelectorAll(this.SELECTORS.searchBtn);
    this.headerHeight = this.$component.offsetHeight;
    this.layersContainer = this.$component.querySelector(this.SELECTORS.layersContainer);
    if(this.layersContainer != null) this.layersContainer.style.transition = 'opacity .5s ease-in-out .2s';
    this.benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    this.activeSecondLevelLayer = false;
    this.searchLayer = this.$component.querySelector(this.SELECTORS.searchLayer);
    this.searchOverlay = this.$component.querySelector(this.SELECTORS.searchOverlay);
    this.searchMobile = this.$component.querySelector(this.SELECTORS.searchMobile);
    this.searchHeightMobile = this.$component.querySelector(this.SELECTORS.searchHeightMobile);
    this.searchOffsetHeightMobile = this.searchHeightMobile !== null ? this.searchHeightMobile.offsetHeight : 0;
    this.actionsMobileSearch = this.$component.querySelector(this.SELECTORS.actionsMobileSearch);
    this.menuItemsLinkSel = this.$component.querySelectorAll(this.SELECTORS.menuItemsLinkSel);
    this.isTablet = window.matchMedia('(max-width: 991px)').matches;
  }

  render() {
    super.render();
    this.setCustomVar();
    this.listenResize();
    if($(window).width() < 992) { //The feature runs only for tablet and mobile to avoid a graphics bug that only occurs for desktop (MC-4695)
      this.listenScroll();
    }
    this.listenBurger();
    this.bindSearchBtnEvents();
    this.setMenuItems();
    this.menuItemsLinkEvents();
    this.bindEvents();
  }

  listenResize() {
    window.addEventListener('resize', () => {
      this.headerHeight = this.$component.offsetHeight;
      this.searchOffsetHeightMobile = this.searchHeightMobile ? this.searchHeightMobile.offsetHeight : this.searchOffsetHeightMobile;
      this.setMenuItems();
      this.setCustomVar();
    });
  }

  setMenuItems() {
    this.menuItems = [];
    let items = this.$component.querySelectorAll(this.SELECTORS.menuItems);

    if(items && items.length > 0) {
      items.forEach(item => {
        let menuItem = new MenuItem(item, this.layersContainer);
        this.menuItems.push(menuItem);
      });
    }
  }

  hideSecondLvlNav() {
    if (this.menuItems.length < 1) {
      return;
    }
    this.menuItems.forEach(menuItem => {
      menuItem.hidePanel();
    });
  }

  listenScroll() {
    let self = this;
    window.addEventListener('scroll', () => {
      self.headerHeight = self.$component.offsetHeight;
      let barHeight = self.benefitBar !== null ? self.benefitBar.offsetHeight : 0;
      // If the class header-is-sticky is not present, the value of self.searchOffsetHeightMobile will not be modified
      if(!self.$component.classList.contains(self.CSS_CLASSNAMES.headerIsSticky)) {
        self.searchOffsetHeightMobile = self.searchHeightMobile ? self.searchHeightMobile.offsetHeight : self.searchOffsetHeightMobile;
      }
      // To enhance activeHeaderSticky, barHeight/2 is subtracted from the check, as it is a value very close to the threshold within which the search bar needs to compress
      const activeHeaderSticky = window.scrollY > self.searchOffsetHeightMobile - barHeight/2;
      activeHeaderSticky ? self.$component.classList.add(self.CSS_CLASSNAMES.headerIsSticky) : self.$component.classList.remove(self.CSS_CLASSNAMES.headerIsSticky);
      if(window.scrollY == 0) {
        self.$component.classList.remove(self.CSS_CLASSNAMES.headerIsSticky);
      }
      self.setCustomVar();
    });
  }

  setCustomVar() {
    const root = document.documentElement;

    root.style.setProperty(this.CSS_CUSTOMVARS.jsHeightHeader, `${this.headerHeight - this.searchOffsetHeightMobile}px`);
    root.style.setProperty(this.CSS_CUSTOMVARS.jsVh, `${window.innerHeight * 0.01}px`);
  }

  bindSearchBtnEvents() {
    let self = this;
    if(this.searchBtnItems && this.searchBtnItems.length > 0) {
      this.searchBtnItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          self.$emit(self.$customEvents.SEARCH_LAYER_EVENTS.open);
          self.searchIsOpen = true;
        });
      });
    }
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.open, () => {
      if(self.menuIsOpen) {
        self.$emit(self.$customEvents.MENU_EVENTS.hideMenu);
        self.menuIsOpen = false;
      }
      self.searchBtnItems.forEach((item, index) => {
        item.disabled = true;
      });
      self.$component.classList.add(self.CSS_CLASSNAMES.searchLayerOpened);
    });
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.close, () => {
      self.searchBtnItems.forEach((item, index) => {
        item.disabled = false;
      });
      self.$component.classList.remove(self.CSS_CLASSNAMES.searchLayerOpened);
    });

    if(this.searchOverlay != null) {
      this.searchOverlay.addEventListener('click', () => {
        self.$emit(self.$customEvents.SEARCH_LAYER_EVENTS.close);
        self.searchIsOpen = false;
      });
    }
  }

  listenBurger() {
    let self = this;
    if(this.burgerMenu != null) {
      this.burgerMenu.addEventListener('click', () => {
        self.menuIsOpen
          ? self.$emit(self.$customEvents.MENU_EVENTS.hideMenu)
          : self.$emit(self.$customEvents.MENU_EVENTS.showMenu);
        self.menuIsOpen = !self.menuIsOpen;
      });
    }
  }

  checkActiveSecondLevelLayer() {
    if(this.menuItems && this.menuItems.length > 0) {
      this.menuItems.forEach((menuItem, index) => {
        if(menuItem.item.hasAttribute('data-pre-open')) {
          showPanel(menuItem);
          this.activeSecondLevelLayer = true;
        }
      });
    }
  }

  menuItemsLinkEvents() {
    let self = this;
    if(this.menuItemsLinkSel && this.menuItemsLinkSel.length > 0) {
      this.menuItemsLinkSel.forEach((item, index) => {
        item.addEventListener('click', () => {
          if(item.dataset.preventDefaultEvent) {
            event.preventDefault();
          }
        });
      });
    }
  }

  bindEvents() {
    let self = this;
    let scrollY;
    self.$on(self.$customEvents.MENU_EVENTS.showMenu, () => {
      if(self.searchIsOpen) {
        self.$emit(self.$customEvents.SEARCH_LAYER_EVENTS.close);
        self.searchIsOpen = false;
      }
      self.checkActiveSecondLevelLayer();
      self.burgerMenu.classList.add(self.CSS_CLASSNAMES.burgerOpen);
      /*
      self.actionsMobileSearch.style.opacity = "1";
      */
      //self.actionsMobileSearchToggleVisibility();
      if(self.activeSecondLevelLayer) {
        self.$component.classList.add(self.CSS_CLASSNAMES.showMenu);
      } else {
        self.$component.classList.add(self.CSS_CLASSNAMES.showMenu);
      }
      let barHeight = self.benefitBar !== null ? self.benefitBar.offsetHeight : 0;
      scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${barHeight}px`;
      document.body.style.width = '100%';
    });
    self.$on(self.$customEvents.MENU_EVENTS.hideMenu, () => {
      self.burgerMenu.classList.remove(self.CSS_CLASSNAMES.burgerOpen);
      if(!self.$component.classList.contains(self.CSS_CLASSNAMES.headerIsSticky)) {
        /*
        self.actionsMobileSearch.style.opacity = "0";
        */
        //self.actionsMobileSearchToggleVisibility(false);
      }
      self.$component.classList.remove(self.CSS_CLASSNAMES.showMenu);
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
      self.hideSecondLvlNav();
      self.activeSecondLevelLayer = false;
    });
  }
}
